import axios from 'axios';
function obtenerNoticias() {
  return axios.get("/obtener_noticias")
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function crearNoticia(noticia) {
  try {
    const response = axios.post('/crear_noticia', noticia, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    return { status: 'fail', error };
  }
}
function actualizarNoticia(noticia) {
  return axios.post("/actualizar_noticia", noticia)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function estadoNoticia(noticia) {
  return axios.post("/estado_noticia", noticia)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function eliminarNoticia(noticiaId) {
  return axios.post("/eliminar_noticia", { id: noticiaId })
    .then((response) => {
      if (response.data && response.data.status === "success") {
        return response.data;
      } else {
        throw new Error(response.data.message || "Error desconocido");
      }
    })
    .catch((error) => {
      console.error("Error eliminando noticia:", error);
      throw error;
    });
}
export {obtenerNoticias, crearNoticia, actualizarNoticia, estadoNoticia, eliminarNoticia};
